const lodash = require('lodash');

// NOTE: This is var, not let, because of how rewire works, which we use for unit testing
var cachedConfig;
const defaultSymbol = Symbol('unsetDefault');
const WELL_KNOWN_GLOBAL_CONFIG_LOCATION_KEY = 'CONFIGS';
const get = function (lookupKey, defaultValue = defaultSymbol) {
  /**
   * This is different from the node version. Since we don't have an async operation, this matches the get API there.
   *
   * The library has been this way for years, so although it isn't pure in the sense that the interface behavior is consistent
   * between node and browser, it's proven to be useful enough, and simple enough, for that not to be an issue.
   */
  if (!cachedConfig) {
    init();
  }
  if (!lookupKey) {
    return cachedConfig;
  }
  const value = lodash.get(cachedConfig, lookupKey, null);
  if (value !== null) {
    return value;
  }
  if (defaultValue !== defaultSymbol) {
    return defaultValue;
  }
  throw Error(`lookup for required config not found: ${lookupKey}`);
};
const init = config => {
  cachedConfig = config || (window || {})[WELL_KNOWN_GLOBAL_CONFIG_LOCATION_KEY];
  if (typeof cachedConfig !== 'object') {
    throw new Error(`Could not find suitable configs`);
  }
};
const initialize = init;

// NOTE: This is important. This export gets translated into a default export, which is what we want.
// If we just used `export` here, it would require es6 callers to use `import * as configment`, which is not what we
// want -- this is used so often that breaking existing apps is not worth it.
module.exports = {
  init,
  initialize,
  get
};
